import { render, staticRenderFns } from "./IncludedCourses.vue?vue&type=template&id=bd5265a0&scoped=true"
import script from "./IncludedCourses.vue?vue&type=script&lang=js"
export * from "./IncludedCourses.vue?vue&type=script&lang=js"
import style0 from "./IncludedCourses.vue?vue&type=style&index=0&id=bd5265a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5265a0",
  null
  
)

export default component.exports